import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import homeLogo from "../../Assets/homelogo.jpeg";
import Particle from "../Particle";
import Type from "./Type";
import Button from "react-bootstrap/Button";
import pdf from "../../Assets/Resume.pdf";
import { AiOutlineDownload } from "react-icons/ai";

function Home() {
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                Hi There! <span className="wave" role="img" aria-labelledby="wave">👋🏻</span>
              </h1>

              <h1 className="heading-name">
                I'M
                <strong className="main-name"> Sumit Kumar Bhandari</strong>
              </h1>

              <div style={{ padding: 50, textAlign: "left" }}>
                <Type />
              </div>

              <div style={{ padding: "10px 50px 80px ", textAlign: "left" }}>

              <Button variant="primary" href={pdf} target="_blank">
              <AiOutlineDownload />
               &nbsp;Resume
              </Button>

              </div>
             
            </Col>

            <Col md={5} style={{ paddingBottom: 20,display:"flex", justifyContent:"center",alignItems:"center"}}>
              <img style={{borderRadius:"50%",width:"70%"}} src={homeLogo} alt="home pic" className="img-fluid" />
            </Col>
            
          </Row>
       
        </Container>
    
      </Container>
  
    </section>
  );
}

export default Home;
